module.exports = __webpack_public_path__ + "img/allottee3_7-8-2021.99868093.jpg";